export default "__VITE_ASSET__Do9R_cPY__"